<template>
  <header class="eleHeads mainbg-color">
    <div class="eleHead">
      <div class="center_c">
        <span
          :class="`${iconStatus} icon_logo`"
          @click="smMenu" />
        <div class="right">
          <div class="locale" @click="changeLocale">
            <img width="18px" :src="localeImg" style="margin-right: 4px;"></img>
            <span v-if="$i18n.locale === 'zh-CN'"> 中文 </span>
            <span v-else-if="$i18n.locale === 'en'"> English </span>
          </div>
          <div
            class="back"
            @click="goBack">
            <i class="el-icon-switch-button" />
            <span>{{$t('components.eleHead.loginOut')}}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import api from '@/api';
export default {
  name: 'eleHeads',
  data () {
    return {
      iconStatus: 'el-icon-s-fold',
      localeImg: require("@/assets/img/Chinese.svg")
    };
  },
  computed: {
    ...mapGetters(['$user']),
    ...mapMutations({
      SET_DEFAULT_ACTIVE_MENU: 'SET_DEFAULT_ACTIVE_MENU'
    })
  },
  created () {
    this.$i18n.locale = localStorage.getItem('locale') || 'zh-CN'
    if (this.$i18n.locale === 'en') this.localeImg = require("@/assets/img/English.svg")
    else if(this.$i18n.locale === 'zh-CN') this.localeImg = require("@/assets/img/Chinese.svg")
  },
  methods: {
    // 菜单抽屉操控
    smMenu () {
      if (this.iconStatus === 'el-icon-s-fold') {
        this.iconStatus = 'el-icon-s-unfold';
      } else {
        this.iconStatus = 'el-icon-s-fold';
      }
      this.$emit('controlMenu', this.iconStatus);
    },
    goBack () {
      api.logout({ login: '1' }).then((res) => {
        // this.SET_DEFAULT_ACTIVE_MENU('/censusUser')
        this.$confirm(this.$t('components.eleHead.tipContent'), this.$t('components.eleHead.tipTitle'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
        }).then(() => {
          this.$message.success(this.$t('components.eleHead.loginOutMsg'));
          //

          window.location.href = window.location.origin + '/logout';
          // this.$router.push('/login')
        });
      });
    },
    changeLocale () {
      let locale = 'zh-CN'
      if (this.$i18n.locale === 'zh-CN') locale = 'en'
      localStorage.setItem('locale', locale)
      document.location.reload() 
    }

  }
};
</script>

<style lang="less" scoped>
.eleHead {
  z-index: 999;
  box-sizing: border-box;
  width: 100%;
  padding: 19px 16px;
  background: #ffffff;
  box-shadow: 4px 2px 11px 0px #e3e6f2;
  .center_c {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .icon_logo {
      display: inline-block;
      cursor: pointer;
    }
  }
}
.right {
  display: flex;
  align-items: center;
  .locale {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eleHead.vue